function selectScreenshotOfCanvas() {
  initPushPinExtension(function () {
    removeInspectionItemPushPins();
  });

  $('body').addClass('taking-screenshot');
  window.dispatchEvent(new Event('resize'));
}

function takeScreenshotOfCanvas() {
  getScreenshowOfCanvas();
  $('body').removeClass('taking-screenshot');
  window.dispatchEvent(new Event('resize'));
}

function getScreenshowOfCanvas() {
  var canvas = $('.canvas-wrap canvas')[0];

  canvas.toBlob(function (blob) {
    // Preview image
    var url = URL.createObjectURL(blob);
    $('.edit-issue__screenshot-preview').css({ backgroundImage: 'url(' + url + ')' });
  });

  // Save data
  var base64Image = canvas.toDataURL();
  $('.edit-issue__screenshot-preview').data('screenshot-image', base64Image);
}
